
import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';


import GridContainer from 'components/MaterialKit/Grid/GridContainer.js';
import GridItem from 'components/MaterialKit/Grid/GridItem.js';
import Parallax from 'components/MaterialKit/Parallax/Parallax.js';
import FrontSubsection from 'layouts/FrontSubsection';
import SideDots from 'components/Layout/SideDots';

// sections for this page
import SectionProject from 'pages-sections/about-us/SectionProject.js';
import SectionTeam from 'pages-sections/about-us/SectionTeam.js';
import SectionSponsors from 'pages-sections/about-us/SectionSponsors.js';

import aboutUsStyle from 'assets/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js';

const useStyles = makeStyles(aboutUsStyle);

const AboutUsPage = () => {
    const classes = useStyles();
    return (
        <>
            <SideDots elements={[
                {
                    link:'#the-project',
                    name:'The Project'
                },
                {
                    link:'#sponsors',
                    name:'The Sponsors'
                },
                {
                    link:'#the-team',
                    name:'The Team'
                },
            ]} />
            <Parallax image={require('assets/img/mines7.jpg')} filter="dark" small>
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem
                            md={8}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >
                            <h1 className={classes.title}>About Us</h1>
                            <h4>
                Meet the amazing team behind this project and find out more about what we do
                            </h4>
                        </GridItem>
                    </GridContainer>
                </div>
            </Parallax>
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                    <SectionProject />
                    <SectionSponsors />
                    <SectionTeam />
                </div>
            </div>
        </>
    );
};

AboutUsPage.layout = FrontSubsection;

export default AboutUsPage;